/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Medialibraryposition2Inputs */

const en_medialibraryposition2 = /** @type {(inputs: Medialibraryposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} of ${i?.total}`)
};

const de_medialibraryposition2 = /** @type {(inputs: Medialibraryposition2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} von ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{current} of {total}" |
*
* @param {Medialibraryposition2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryposition2 = /** @type {((inputs: Medialibraryposition2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryposition2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryposition2(inputs)
	return de_medialibraryposition2(inputs)
});
export { medialibraryposition2 as "mediaLibraryPosition" }